/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvZWotdHMvbGF5b3V0L3Nlc3Npb24tdGltZW91dC9zZXNzaW9uLXRpbWVvdXQuY29tcG9uZW50LmNzcyJ9 */"];
export { styles as styles };
